import React from "react";
import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";

import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

import Search from "./components/Search";
import AlertWindow from "./components/AlertWindow";
import mapStyles from "./mapStyles";
import MapPin from "../../svg/mappin.svg";
import Poi from "../../svg/poi.svg";

import Clinic from "./clinic.svg";
import EmergencyClinic from "./emergencyClinic.svg";
import MobileEmergencyClinic from "./mobileEmergencyClinic.svg";

import ClinicSVG from "../../svg/clinic.svg";
import EmergencyClinicSVG from "../../svg/emergencyClinic.svg";
import MobileEmergencyClinicSVG from "../../svg/mobileEmergencyClinic.svg";

const libraries = ["places"];
const mapContainerStyle = {
  height: "80vh",
};
const options = {
  styles: mapStyles,
  disableDefaultUI: true,
  zoomControl: true,
};
const center = {
  lat: 52.32769994490447,
  lng: 9.778637426587638,
};

export const SgvRenderer = ({ svg }) => {
  return svg;
};

const MapComponent = ({ clinics, handleSendingData, handleTelefonInfoModal, formData }) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.GATSBY_GOOGLE_MAPS_API_KEY,
    libraries,
  });
  const [selected, setSelected] = React.useState();
  const [currentPosition, setCurrentPosition] = React.useState({});
  const [searchedPosition, setSearchedPosition] = React.useState({});

  const [filter, setFilter] = React.useState({
    emergencyClinic: true,
    clinic: true,
    mobileEmergencyClinic: true,
  });

  const handleChange = (event) => {
    setFilter({ ...filter, [event.target.name]: event.target.checked });
  };

  const filteredClinics = React.useMemo(() => {
    let filtered = [];

    if (filter.emergencyClinic && filter.clinic && filter.mobileEmergencyClinic) {
      filtered = clinics;
    }
    if (filter.emergencyClinic && filter.clinic && !filter.mobileEmergencyClinic) {
      // filter out mobileEmergencyClinic
      filtered = clinics.filter((clinic) => clinic.type !== "mobileEmergencyClinic");
    }
    if (filter.emergencyClinic && !filter.clinic && !filter.mobileEmergencyClinic) {
      // filter out clinic & mobileEmergencyClinic
      filtered = clinics.filter(
        (clinic) => clinic.type !== "mobileEmergencyClinic" && clinic.type !== "clinic"
      );
    }
    if (!filter.emergencyClinic && !filter.clinic && !filter.mobileEmergencyClinic) {
      // filter out emergencyClinic & clinic & mobileEmergencyClinic
      return [];
    }
    if (!filter.emergencyClinic && !filter.clinic && filter.mobileEmergencyClinic) {
      // filter out emergencyClinic & clinic
      filtered = clinics.filter(
        (clinic) => clinic.type !== "emergencyClinic" && clinic.type !== "clinic"
      );
    }
    if (!filter.emergencyClinic && filter.clinic && !filter.mobileEmergencyClinic) {
      // filter out emergencyClinic & mobileEmergencyClinic
      filtered = clinics.filter(
        (clinic) => clinic.type !== "emergencyClinic" && clinic.type !== "mobileEmergencyClinic"
      );
    }
    if (filter.emergencyClinic && !filter.clinic && filter.mobileEmergencyClinic) {
      // filter out clinic
      filtered = clinics.filter((clinic) => clinic.type !== "clinic");
    }
    if (!filter.emergencyClinic && filter.clinic && filter.mobileEmergencyClinic) {
      // filter out clinic
      filtered = clinics.filter((clinic) => clinic.type !== "emergencyClinic");
    }
    return filtered;
  }, [filter]);

  // const filteredClinics = filtering || []

  const onMapClick = React.useCallback((e) => {
    // console.log("the map was clicked here:", e)
  }, []);

  const mapRef = React.useRef();
  const onMapLoad = React.useCallback((map) => {
    mapRef.current = map;
  }, []);
  const panTo = React.useCallback(({ lat, lng }) => {
    mapRef.current.panTo({ lat, lng });
    mapRef.current.setZoom(9);

    let latTrimmed = Math.floor(lat * 1000) / 1000;
    let lngTrimmed = Math.floor(lng * 1000) / 1000;

    if (Array.isArray(filteredClinics)) {
      filteredClinics.map((clinic) => {
        if (
          Math.floor(clinic.coordinates?.latitude * 1000) / 1000 === latTrimmed &&
          Math.floor(clinic.coordinates?.longitude * 1000) / 1000 === lngTrimmed
        ) {
          setSelected(clinic);
        }
      });
    }

    const searchedPosition = {
      lat: lat,
      lng: lng,
    };
    if (!selected) {
      setSearchedPosition(searchedPosition);
    }
  }, []);

  if (loadError) return "Error";
  if (!isLoaded) return "Loading map...";

  const handleMarkerClick = (clinic) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        console.log(position);
        const currentPosition = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        setCurrentPosition(currentPosition);
      },
      () => null
    );

    setSelected(clinic);
  };

  return (
    <>
      <div className="card info--mapCard" id="map">
        <div className="infoCardHeader--grid">
          <div className="infoCardHeader--wrapper">
            <div className="infoCardHeaderIcon--grid">
              <div className="icon--background">
                <MapPin style={{ margin: "3px 10px" }} />
              </div>
              <h1>Tiernotdienst Finden</h1>
            </div>
          </div>
          <hr className="rounded" />
        </div>

        <div className="mapsearch--flex">
          <button
            className="button mapsearch--locate"
            onClick={() => {
              navigator.geolocation.getCurrentPosition(
                (position) => {
                  console.log(position);
                  const currentPosition = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                  };
                  setCurrentPosition(currentPosition);
                  panTo({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                  });
                },
                () => null
              );
            }}
          >
            <span>Tiernotdienste in Deiner Nähe</span> <Poi />
          </button>
          <span className="mapsearch--flex__divider"></span>
          <Search panTo={panTo} />
        </div>
        <div className="map--filter">
          <FormGroup className="map--filter__formGroup">
            <>
              <FormControlLabel
                control={
                  <Switch
                    checked={filter.emergencyClinic}
                    onChange={handleChange}
                    name="emergencyClinic"
                    color="primary"
                  />
                }
                label={
                  <div className="map--filter__formGroup__label">
                    <span>Notfallpraxis</span>
                    <EmergencyClinicSVG />
                  </div>
                }
              />
              {/* <EmergencyClinicSVG/> */}
            </>
            <FormControlLabel
              control={
                <Switch
                  checked={filter.clinic}
                  onChange={handleChange}
                  name="clinic"
                  color="primary"
                />
              }
              label={
                <div className="map--filter__formGroup__label">
                  <span>Kleintierklinik</span>
                  <ClinicSVG />
                </div>
              }
            />

            <FormControlLabel
              control={
                <Switch
                  checked={filter.mobileEmergencyClinic}
                  onChange={handleChange}
                  name="mobileEmergencyClinic"
                  color="primary"
                />
              }
              label={
                <div className="map--filter__formGroup__label">
                  <span>mobile Notfallpraxis</span>
                  <MobileEmergencyClinicSVG/>
                </div>
                }
            />
          </FormGroup>
        </div>
        <div className="mapsearch--tip">
          <p>
            Tip: Bevor Du Dich auf den Weg machst, raten wir Dir, in der Klinik anzurufen und Deinen
            Besuch anzukündigen. Nicht alle Kliniken bieten telefonische Beratung rund um die Uhr
            an.
          </p>
        </div>
        <div className="map--wrapper">
          <GoogleMap
            id="map"
            mapContainerStyle={mapContainerStyle}
            zoom={7}
            center={center}
            options={options}
            onClick={onMapClick}
            onLoad={onMapLoad}
          >
            {Array.isArray(filteredClinics) &&
              filteredClinics.map((clinic) => {
                const type = {
                  clinic: Clinic,
                  emergencyClinic: EmergencyClinic,
                  mobileEmergencyClinic: MobileEmergencyClinic,
                };

                const clinicType = clinic.type ? type[clinic.type] : "clinic";

                return (
                  clinic.coordinates && (
                    <Marker
                      key={clinic.id}
                      position={{
                        lat: clinic.coordinates.latitude,
                        lng: clinic.coordinates.longitude,
                      }}
                      onClick={() => handleMarkerClick(clinic)}
                      icon={{
                        // url: require(`./${clinicType}.svg`),
                        url: clinicType,
                        origin: new window.google.maps.Point(0, 0),
                        anchor: new window.google.maps.Point(15, 15),
                        scaledSize: new window.google.maps.Size(30, 30),
                      }}
                    />
                  )
                );
              })}
            {currentPosition.lat && <Marker key={"test"} position={currentPosition} />}
            {searchedPosition.lat && <Marker key={"test11"} position={searchedPosition} />}

            {selected && (
              <AlertWindow
                selected={selected}
                currentPosition={currentPosition}
                close={() => setSelected(null)}
                handleSendingData={handleSendingData}
                handleTelefonInfoModal={handleTelefonInfoModal}
                formData={formData}
              />
            )}
          </GoogleMap>
        </div>
      </div>
    </>
  );
};

export default MapComponent;
